export default __webpack_public_path__ + "d1c298e3a54af327eca4df41df127c23.png";